import { memo } from 'react'
import { LoadingPage } from '@panwds/react-ui'
import { getFrameworkVar } from '../../framework/states'
import './LoadingPlaceholder.scss'
import type { VFC } from 'react'

const LoadingPlaceholder: VFC<{}> = () => (getFrameworkVar('use_new_left_nav') ? (
  <div className='spk-load-container'><LoadingPage /></div>
) : (
  <div className='spk-load-container loader'></div>
))

export default memo(LoadingPlaceholder)
